<template>
	<div  v-loading="loading" id="knowdetail">
		<Header></Header>
		<div class="container">
			<div class="titles">
				{{shop.title}}
			</div>
			<div class="container-box">
				<div style="height:600px">
					<div>
						<div  v-if="srctab ==false" style="width:485px;height:475px;background-size:cover;background-position:50%"   :style="{backgroundImage:'url('+shop.cover_img+')'}"></div>
						<img v-if="srctab ==1" style="width:485px;height:475px" v-lazy="lazyImg(album[0])" >
						<img v-if="srctab ==2" style="width:485px;height:475px" v-lazy="lazyImg(album[1])">
						<img v-if="srctab ==3" style="width:485px;height:475px" v-lazy="lazyImg(album[2])" >
						<img v-if="srctab ==4" style="width:485px;height:475px" v-lazy="lazyImg(album[3])" >
					</div>
					<div class="foot-img">
						<div style="width:119px;height:119px;background-size:cover;background-position:50%"  v-for="(item,index) in shop.album" v-bind:key="item.id"
							  ref="picDom" @click="pictab(index)"
							  :class="index == 0? 'first-pictab' : 'pictab'"
							  v-if="index <= 3"
							  :style="{backgroundImage:'url('+item+')'}"></div>
					</div>
				</div>
				<div class="right-detail">
					<div class="detail">
						  <div>相关帖子</div>
						  <!--<div><img style="width:27px;height:27px;margin-right:5px;" src="../../assets/wjxk.png" alt=""></div>-->
						</div>
						<!--<div class="detail">
						  <div></div>
						  <div style="color:#5e5e5e;font-size:18px;">收藏</div>
						</div>-->
						<div class="about-post">
						  <div class="block">
							  <el-carousel  indicator-position="outside">
								  <el-carousel-item v-for="item in post" :key="item.index">
								<a target="_blank" style="text-decoration:none;" :href="'http://www.hd199.com/thread-' + item.tid +'-1-1.html'">
								  <div class="post-title">{{item.subject}}</div>
								  <div class="post-detail">
									  <div class="photo">
										  <img :src='aboutPic(item.authorid)' alt="">
										  </div>
									  <div  class="name">{{item.author}}</div>
									  <div class="time">
										  <img src="../../assets/sj.png" alt="">
										  		 {{item.dateline | time}}
									  </div>
								  </div>
								</a>
								  </el-carousel-item>
							  </el-carousel>
						  </div>
						</div>
					<div class="detail">
						<div style="line-height:49px">全网比价</div>
							<div v-if="shop.is_favorite==1"  @click="collectShop(false)" class="collect">
								<img style="width:26px;height:27px" src="@/assets/collect.png" alt="">
								<div style="width:80px;" >取消</div>
							</div>
							<div v-else  @click="collectShop(true)" class="collect">
								<img style="width:26px;height:27px" src="@/assets/sc.png" alt="">
								<div style="width:80px;" >收藏</div>
							</div> 
				　　</div>
				<div v-for="item in shop.shoplink" v-bind:key='item.id' style="margin-top:14px;" class="compare-money">
				<a target="_blank" style="text-decoration:none;" :href="item.url|escapeHtml"><div class="shop-name">{{item.title}}</div></a>
					<div class="shop-star">
						<div class="left-star">
							店铺评分：<img src="../../assets/wjx.png" alt="">
							<img src="../../assets/wjx.png" alt="">
							<img src="../../assets/wjx.png" alt="">
							<img src="../../assets/wjx.png" alt="">
							<img src="../../assets/wjxk.png"alt="">
						</div>
						<div class="right-money">
							<span style="font-size:14px">￥</span>{{item.price}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="container">
		<div class="title">
			<span>详情描述</span>
		</div>
		<div class="describe">
			<div v-html="shop.content" style="margin-top:12px;padding-left:0px"></div>
		</div>
	</div>
	<div class="container">
		<div style="padding-top:25px;">
			<div class="title">
				<span>评论({{totals.total}})</span>
			</div>
			<div  v-for="item in comment" v-bind:key="item.id">
				<div class="list-box">
					<div class="comment-box">
						<div class="comment-pic">
							<div><img :src="item.bbs.user_avatar" alt=""></div>
						</div>
						<div>
							<div class="comment-name"><span>{{item.bbs.user_name}}</span> &nbsp{{item.content}}</div>
							<div class="time">{{item.create_time|time}}</div>
						</div>
					</div>
					<div class="msg" @click="reply(item.id)">
						<img style="width:24;height:20px" src="@/assets/send.png" alt="">
					</div>
				</div>
				<div v-for="items in item._children" v-bind:key="items.id" class="list-box">
					<div style="margin-left:50px" class="comment-box">
						<div class="comment-pic">
							<div><img :src="items.bbs.user_avatar" alt=""></div>
						</div>
						<div>
							<div class="comment-name">{{items.bbs.user_name}}<span></span>回复<span>{{item.bbs.user_name}}</span> &nbsp{{items.content}}</div>
							<div class="time">{{items.create_time|time}}</div>
						</div>
					</div>
				</div>
			</div>
			<div v-if="comment.length != 0" class="pagination">
				<el-pagination
						background
						@current-change="changePage"
						:current-page="bbs_page.current_page"
						:page-size="10"
						layout="prev, pager, next"
						:total="bbs_page.total">
				</el-pagination>
				<span>共{{pagenum.last_page}}页</span>
			</div>
			<div v-show="!isShowLogin"  class="send-box">
				<div v-show="!isShowLogin" >
					<img :src="avatar_url" alt="">
				</div>

				<div v-show="!isShowLogin"  class="text-input">
					<textarea placeholder="请输入评论" v-model="text" name="" id="" cols="" rows="16"></textarea>
				</div>
			</div>
			<div v-show="!isShowLogin"  class="foot-button"> <button style="outline:none;" :disabled='disabled' @click="sendComment">发表评论</button></div>
		</div>
<!--		<div class="title">
			<span>评论</span>
		</div>
		<div class="list-box">
			<div v-for="item in comment" v-bind:key="item.index" class="classify">
				<div class="flex-box">
					<div class="photos"><img :src="item.bbs.user_avatar" ></div>
					<div class="right-text">
						<div style="margin-left:0" class="names">
							<div class="name-title">{{item.bbs.user_name}}</div>
						</div>
						<div style="margin-left:0" class="time">{{item.create_time|time}}</div>
						<div class="text-container">{{item.content}}</div>
					</div>
				</div>
			</div>
		</div>-->
	</div>
	<ReturnBox :ReturnBoxDialog.sync="ReturnBoxDialog" :parent_id="parent_id" :goods_id="shop.id" :avatar="avatar_url"></ReturnBox>
	<Foot></Foot>
	</div>
</template>

<script>
	import {getBrandList} from '@/api/secendHands/axios'
	import {getVideoList} from '@/api/secendHands/axios'
	import {getCondition} from '@/api/secendHands/axios'
	import Foot from '@/components/common/Foot'
	import Header from '@/components/knowshop/Header'
	import Mixin from '@/common/js/mixin'
	import {BBSHOST} from '@/config/config'
	import ReturnBox from '@/components/common/ReturnBox'
	export default {
		mixins: [Mixin],
		name: 'App',
		data() {
			return {
				avatar_url:localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')).avatar_url:'',
				totals:[],  //评论次数
				input: '',
				value: '',
				valueA:'',
				valueB:'',
				valueC:'',
				checked:'',
				check:'',
				dialogVisible: false,
				condition:[],
				brand:[],
				video:[],
				fileList:[{}],
				shop:[],
				comment: [],
				child:[],
				goodcomment:'',
				items:[
					'全部', '有图', '好评', '差评',
				],
				bbs_page:{
					total:0,
					current_page:0,
					page:1,
				},
				parent_id:'',//父级评论ID
				text:'',
				srctab:false, //图片显示大图
				ReturnBoxDialog:false, //回复框状态
				album:[],
				loading:true,
				post:[],
				pagenum:[],
				disabled:false,
				isShowLogin:true,//是否登录
			};
		},
		components:{
			Foot,
			Header,
			ReturnBox
		},
		created () {
			this.getDetail()
			this.getCommentList()
			this.isLogin()
		},
		methods: {
			// 是否登录
			isLogin(){
			if (getCookie("sid")) {
        this.isShowLogin = false;
      }
			},
			changePage(currentPage){
				this.bbs_page.page = currentPage;
				this.getCommentList();
			},
			aboutPic:function(url){
				return 'http://www.hd199.com/uc_server/avatar.php?uid='+url+'&size=middle'
			},
			handleClose(done) {
				done();
			},
			handleOpen(key, keyPath) {
			},
			//    图片切换
			pictab(index) {
				this.srctab = index + 1
				this.$refs.picDom.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.picDom[Mindex].style.color = '#F9BE04')
						: (this.$refs.picDom[Mindex].style.color = '#D3D3D2')

					index === Mindex ? (this.$refs.picDom[Mindex].style.border = '1px solid #F9BE04')	
						: (this.$refs.picDom[Mindex].style.border = '1px solid #fff')
				})
			},
			collectShop (value) {
				if(value===true){
					this.$post('/apis/discern/discernFavorite',{
						user_id:getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
						goods_id:this.$route.params.id
					}).then((res) => {
						if(res){
							this.$message({
								message:'收藏成功',
								type:'success',
								onClose:()=>{
									this.getDetail()
								}
							});
							console.log(111)
						}
					})
				}else{
					this.$_delete('/apis/discern/discernFavorite/'+this.$route.params.id+'?uid='+getCookie("user")?getCookie("user"):getCookie("dzq_user_id")).then((res)=>{
						if(res){
							this.$message({
								message:'取消收藏成功',
								type:'success',
								onClose:()=>{
									this.getDetail()
								}
							});
							console.log(222)
						}
					})
				}
			},

			getDetail: function () {
				this.$get('/apis/discern/discern/'+this.$route.params.id,{
						params: {
						uid :getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
				}
					}).then((res)=>{
					if(res){
						this.shop = res.data
						this.post = res.data.relatedposts						
						this.album=res.data.album
						this.loading = false
					}
				})
			},
			getCommentList: function () {
				this.$get('/apis/idle/IdleGoodsComment', {
					params: {
						goods_id :this.$route.params.id,
						order:this.goodcomment,
						page:this.bbs_page.page,
						type:2,
					}
				}).then((res)=>{
					if(res){
						this.comment = res.data.data
						this.bbs_page.total=res.data.total;
						this.bbs_page.current_page = res.data.current_page;
						this.totals = res.data
						this.pagenum = res.data
						for(var  j = 0; j < this.comment.length; j++) {
							var child = this.comment[j]
							this.child.push(child);
						}
					}
				})
			},
			// 发表评论
			sendComment () {
				this.disabled = true
				if (this.text == ''){
					this.$message({
						type:'error',
						message:'输入内容不能为空',
					})
					this.disabled = false
				}else{
					this.$post('/apis/idle/IdleGoodsComment',{
						goods_id:this.$route.params.id,
						content:this.text,
						user_id:getCookie("user")?getCookie("user"):getCookie("dzq_user_id"),
						type:2
					}).then((res) => {
						if(res){
							this.$message({
								message:'评论成功',
								type:'success',
								onClose:()=>{
									setTimeout(()=>{
											this.disabled=false
											this.getCommentList()
											this.text = ''}
										,2000)
									this.disabled = true
								}
							});
						}
					})
				}
			},
			// 回复评论
			reply (id){
				if(getCookie("user")?getCookie("user"):getCookie("dzq_user_id")!=''){
					this.parent_id=id;
					this.ReturnBoxDialog=true;
				}else{
					//未登陆
					this.$message({
						type:'error',
						message: '请登录后再评论'
					});
				}
			},
		}
	}
</script>

<style >
	body{
		margin: 0px;
	}
	#knowdetail{
		min-width: 1200px;
	}
	.el-submenu .el-menu{
		z-index: 1;
	}
	#knowdetail .titled {
		height:60px;
		width: 100%;
		background: #272727;
		display: flex;
		justify-content: space-between;
		align-items: center
	}
	#knowdetail .pictab{
		border: 1px solid #fff;
	}
	#knowdetail .collect{
		text-align: center;
		cursor: pointer;
		margin-right: 20px;
	}
	#knowdetail .first-pictab{
		border: 1px solid #F9BE04;
	}
	#knowdetail .title-tab{
		display: flex;
	}
	#knowdetail .title-tab div{
		color: #fff;
		padding-left: 45px;
		font-size: 16px;
		line-height: 40px;
	}
	#knowdetail .vertical{
		width: 1px;
		background: #fff;
		opacity: 0.4;
		margin-left: 11px
	}
	#knowdetail .login-me{
		color:#fff;
		font-size: 16;
		display: flex;
		margin-right: 160px；
	}
	#knowdetail .login-me img{
		height: 14px;
		width: 14px;
	}
	#knowdetail .login-me div{
		margin-right: 37px;
		display: flex;
		align-items: center;
		cursor: pointer
	}
	#knowdetail .login-me span{
		margin-left: 8px;
		margin-top: -3px;
		color: #fff;
		font-size: 14px;
	}
	.el-icon-close:before{
		color: black
	}
	.el-dialog__header{
		background: #F9BE04;
		padding: 16px 20px;
	}
	.el-textarea__inner{
		height: 150px;
	}
	.el-carousel__indicators--outside{
		background: #EFF2F5
	}
	.el-carousel{
		margin-top: 20px;
	}
	#knowdetail .classifys{
		display: flex;
		font-size: 18px;
		color: #303030;
		margin-top: 30px;
		display: flex;
		padding-left: 35px;
		align-items: center;
	}
	#knowdetail .class-list{
		display: flex;
	}
	#knowdetail .select{
		border: 1px solid #D3D3D2;
		border-radius: 8px;
		padding: 0 12px;
		font-size: 12px;
		color: #D3D3D2;
		margin-left: 20px;
	}
	#knowdetail .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
		margin-left: 20px;
		padding: 0 12px;
		font-size: 12px;
	}
	.el-checkbox__label{
		font-size: 16px;
		color: #BCBCBC;
	}
	.el-checkbox__input.is-checked+.el-checkbox__label{
		color:#F9BF07;
	}
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		background: #F9BF07;
		border-color: #F9C00B;
	}
	.el-checkbox__inner:hover{
		border-color: #F9C00B;
	}
	.el-checkbox__input.is-focus.el-checkbox__inner{
		border-color: #F9C00B;
	}
	#knowdetail .load-button{
		background: #F9C213;
		box-shadow: 0 2px 4px 0 rgba(198,198,198,0.50);
		border-radius: 2px;
		border: none;
		color: #fff;
		width: 110px;
		height: 37px;
		margin-left: 3px;
		font-size: 18px;
	}
	.el-textarea{
		width: 80%;
	}
	.dialog-footer{
		display: flex;
		justify-content: center;
	}
	.dialog-footer button{
		border:none;
		background: #F9C213;
		box-shadow: 0 2px 4px 0 rgba(198,198,198,0.50);
		border-radius: 2px;
		height: 37px;
		width: 142px;
		color: #fff;
		font-size: 18px;
	}
	.el-submenu{
		position: absolute;
		top: -28px;
		background: #272727;
		width: 110px;
	}
	.el-menu-item.is-active{
		color: #F9C213;
	}
	.el-submenu__title:hover{
		background: #272727;
	}
	.el-submenu__title{
		padding: 0 !important;
	}
	.el-submenu .el-menu-item{
		padding: 0 !important;
		min-width: 0;
		text-align: center;
	}
	#knowdetail .titles{
		font-size: 20px;
		color: #353535;
		text-align: center;
		margin-top: 10px;
	}
	#knowdetail .container-box{
		margin-top: 32px;
		display: flex;
		margin-top: 10px;
	}
	#knowdetail .detail{
		font-size: 20px;
		color: #353535;
		display: flex;
		justify-content: space-between;
	}
	#knowdetail .right-detail{
		margin-left: 40px;
		width: 100%;
	}
	#knowdetail .foot-img{
		display: flex;
	}
	#knowdetail .foot-img img{
		width: 119px;
		height: 119px;
	}
	#knowdetail .about-post{
		background: #EDEDED;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background: #fbfbfb;
	}

	.el-carousel__item:nth-child(2n+1) {
		background: #fbfbfb;
	}
	.el-carousel__container{
		height: 107px;
	}

	.el-carousel__indicators--outside{
		background: #fff;
	}
	.el-carousel__indicator.is-active button{
		background: #F9C00B;
	}
	.el-carousel__indicators--outside button{
		width: 10px;
		height: 10px;
		border-radius: 5px;
	}
	#knowdetail .post-detail{
		display: flex;
		line-height: 38px;
		margin-top: 14px;
		margin-left: 13px;
	}
	#knowdetail .photo img{
		width: 38px;
		height: 38px;
		border-radius: 19px;
	}
	#knowdetail .post-title{
		font-size: 20px;
		color: #232323;
		margin-top: 12px;
		margin-left: 13px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis
	}
	#knowdetail .name{
		font-size: 18px;
		color: #F9BE04;
		margin-left: 11px;
	}
	#knowdetail .time{
		font-size: 12px;
		color: #C4C4C4;
		margin-left: 26px;
		align-items: center;
	}
	#knowdetail .compare-money{
		background: #fbfbfb;
		border: 1px solid #fbfbfb;
	}
	#knowdetail .shop-star{
		display: flex;
		justify-content: space-between;
	}
	#knowdetail .shop-name{
		margin-left: 10px;
		margin-top: 13px;
		font-size: 20px;
		color: #232323;
	}
	#knowdetail .shop-name:hover{
		color: #F9BE04;
	}
	#knowdetail .left-star{
		font-size: 12px;
		color: #F9BE04;
		margin-left: 10px;
		margin-top: 13px;
		align-items: center;
	}
	#knowdetail .left-star img{
		width: 11px;
		height: 11px;
	}
	#knowdetail .right-money{
		font-size: 24px;
		color: #F9BE04;
		margin-right: 15px
	}
	#knowdetail .title{
		background: #fbfbfb;
		height: 53px;
		border-left: 5px solid #F9BE04;
		width: 100%;
		line-height: 53px;
	}
	#knowdetail .title span{
		font-size: 20px;
		color: #2E2E2E;
		margin-left: 18px
	}
	#knowdetail .describe{
		font-size: 12px;
		color: #2E2E2E;
		margin-left: 23px;
	}
	#knowdetail .container{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
		overflow: hidden;
		margin-top: 20px;
		padding-bottom: 10px;
	}
	#knowdetail .title{
		background: #fbfbfb;
		height: 53px;
		border-left: 5px solid #F9BE04;
		width: 100%;
		line-height: 53px;
	}
	#knowdetail .title span{
		font-size: 20px;
		color: #2E2E2E;
		margin-left: 18px
	}
	#knowdetail .first-select{
		border: 1px solid #F9BE04;
		border-radius: 8px;
		color: #F9BE04;
	}
	#knowdetail .classify{
		border-right: 1px solid #E4E4E4;
		border-bottom: 1px solid #E4E4E4;
		border-left: 1px solid #E4E4E4;
		margin-right: -5px;
	}
	#knowdetail .flex-box{
		display: flex;
	}
	#knowdetail .photos img{
		width: 68px;
		height: 68px;
		border-radius: 34px;
		margin-left: 20px;
		margin-top: 10px;
	}
	#knowdetail .right-text{
		margin-left: 25px;
		width: 100%;
	}
	#knowdetail .names{
		display: flex;
		justify-content: space-between;
		margin-top:10px;
	}
	#knowdetail .time{
		font-size: 12px;
		color: #C4C4C4;
	}
	#knowdetail .text-container{
		font-size: 14px;
		color: #696969;
		margin-top: 7px;
	}
	#knowdetail .text-img{
		margin-top: 15px;
		padding-bottom: 8px;
	}
	#knowdetail .text-img img{
		height: 84px;
		width: 103px;
	}
	#knowdetail .first-img{
		margin-left: 18px;
	}
	#knowdetail .heart{
		display: flex;
		align-items: center;
		font-size: 18px;
		color: #F7C835;
		margin-right: 12px;
	}
	#knowdetail .heart img{
		width: 22px;
		height: 19px;
		padding-right: 5px;
	}
	#knowdetail .name-title{
		font-size: 16px;
		color: #F9BE04;
	}
	#knowdetail .title span{
		font-size: 20px;
		color: #2E2E2E;
		margin-left: 18px
	}
	#knowdetail .comment-pic{
		margin-left: 23px;
		padding-top: 9px;
		padding-bottom: 9px
	}
	#knowdetail .comment-pic img{
		width: 36px;
		height: 36px;
		border-radius: 18px
	}
	#knowdetail .comment-box{
		display: flex;
		justify-content: flex-start;
	}
	#knowdetail .time{
		font-size: 12px;
		color: #C4C4C4;
		margin-left: 13px
	}
	#knowdetail .comment-name{
		font-size: 16px;
		color: #232323;
		line-height: 22px;
		margin-left: 13px;
		margin-top: 9px;
	}
	#knowdetail .comment-name span{
		color: #F9BE04
	}
	#knowdetail .list-box{
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid  #e8e8e8;
		border-left: 1px solid  #e8e8e8;
		border-right: 1px solid  #e8e8e8;
	}
	#knowdetail .msg{
		margin-right: 30px;
		margin-top: 20px;
	}
	#knowdetail .send-box{
		display: flex;
		margin-top: 52px;
	}
	#knowdetail .send-box img{
		width: 58px;
		height: 58px;
	}
	#knowdetail .text-input{
		margin-left: 20px;
		width: 100%;
	}
	#knowdetail .text-input textarea{
		width: 99%;
	}
	#knowdetail .pagination{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	#knowdetail .pagination input{
		width: 28px;
		border: 1px solid #D5D5D5;
		height: 26px;
		margin-left: 4px;
		margin-right: 4px;
	}
	#knowdetail .pagination span{
		font-size: 14px;
		color: #D5D5D5;
		letter-spacing: 0;
		line-height: 18px;
		margin-left: 11px;
	}
	#knowdetail .pagination-button{
		color: #fff;
		background: #F9BE04;
		box-shadow: 0 2px 4px 0 rgba(200,200,200,0.50);
		border-radius: 2px 2px 2px 0 2px;
		border: none;
		height: 30px;
		width: 65px;
		margin-left: 8px;
	}
	#knowdetail .foot-button{
		display: flex;
		justify-content: flex-end;
		margin-top: 18px;
		padding-bottom: 20px;
	}
	#knowdetail .foot-button button{
		background: #F9BE04;
		box-shadow: 0 2px 4px 0 rgba(200,200,200,0.50);
		border-radius: 2px;
		border: none;
		color: #fff;
		width: 138px;
		height: 44px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/knowshop/Detail.vue